export const FDIC_DISCLOSURE =
  'Thera is a financial technology company, not a bank. Banking services are provided by OMB Bank, Member FDIC. ' +
  'Deposits in checking and savings accounts are held by OMB Bank and are eligible for FDIC insurance coverage. ' +
  'FDIC insurance covers the failure of an insured bank; pass-through insurance applies only if specific conditions are met. ' +
  'Fees, terms, and conditions may apply. Please review our Terms of Service and Privacy Policy. ' +
  'Contact us for questions about your privacy and consult a tax advisor for tax-related concerns.';

// Short, one-line bank partnership disclosure surfaced on in-app surfaces
// (e.g. dashboard, settings) where the full FDIC_DISCLOSURE would be too long.
export const BANK_DISCLOSURE_SHORT =
  'Thera is a financial technology company, not a bank.\nBanking services are provided by OMB Bank, Member FDIC.';
